import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'comparative-search-card',
})

export default class ComparativeSearchCard extends Vue {

    // ------------------------------------------------------------------------
    // Properties
    @Prop()
    private cardName?: string;

    @Prop()
    private filterParams: any;

    @Prop()
    private content: any;

    private isLoading: boolean = false;

    private start: number = 0;

    private length: number = 10;

    // -----------------------------------------------------------------------------
    // Actions
    private onShowSearch(url: string) {
        window.open(url, '_blank');
    }

    private handleScroll(e: any) {
        const params: any = this.filterParams;
        const currentScrollPosition = e.srcElement.scrollTop;
        if (currentScrollPosition >= (e.srcElement.scrollHeight - e.srcElement.offsetHeight) && !this.isLoading) {
            this.isLoading = true;
            this.start = this.start + 1;
            params.length = this.length;
            params.start = this.start;
            const options = {
                params,
                isScroll: true,
            };
            if (this.cardName === 'google') {
                this.$store.dispatch('comparativeStore/googleSearch', options).then(() => {
                    this.isLoading  = false;
                });
            } else {
                this.$store.dispatch('comparativeStore/bingSearch', options).then(() => {
                    this.isLoading = false;
                });
            }

        }
    }
}
